export const ui = {
  common: {
    getEstimate: { en: "Get Free Estimate", es: "Estimado Gratis" },
    getQuote: { en: "Get Free Quote", es: "Cotización Gratis" },
    joinTeam: { en: "Join Our Team", es: "Únase al Equipo" },
    callNow: { en: "Call Now", es: "Llame Ahora" },
    hours: { en: "7:00 AM – 5:00 PM · Flexible hours for clients", es: "7:00 AM – 5:00 PM · Horario flexible para clientes" },
    language: { en: "Language", es: "Idioma" },
    openMenu: { en: "Open menu", es: "Abrir menú" },
    closeMenu: { en: "Close menu", es: "Cerrar menú" },
    skip: { en: "Skip to main content", es: "Saltar al contenido principal" },
    tagline: { en: "The Right People. Every Time. Everywhere.", es: "La Gente Correcta. Siempre. En Todas Partes." },
    workforce: { en: "Workforce Support Solutions", es: "Soluciones de Apoyo Laboral" },
    sending: { en: "Sending…", es: "Enviando…" },
    submitError: { en: "Something went wrong. Please call us at 614-382-9458.", es: "Algo salió mal. Llámenos al 614-382-9458." },
  },
  hero: {
    seo: { en: "Professional Cleaning & Staffing Solutions for Columbus, Ohio", es: "Soluciones Profesionales de Limpieza y Personal en Columbus, Ohio" },
    line1: { en: "Clean Spaces.", es: "Espacios Limpios." },
    line2: { en: "Better Business.", es: "Mejores Negocios." },
    subGold: { en: "Reliable people,", es: "Personal confiable," },
    subRest: { en: "custom solutions that keep your business running smoothly — hotels, offices, stores and warehouses across Columbus.", es: "soluciones a la medida que mantienen su negocio funcionando sin problemas — hoteles, oficinas, tiendas y almacenes en todo Columbus." },
    secondary: { en: "View Services", es: "Ver Servicios" },
    reviews: { en: "Google Reviews", es: "Reseñas en Google" },
    reliable: { en: "Reliable Service", es: "Servicio Confiable" },
    trained: { en: "Trained Staff", es: "Personal Capacitado" },
    quality: { en: "Quality Assured", es: "Calidad Garantizada" },
    imageAlt: { en: "Professional Flexhire housekeeping team in black and gold uniforms preparing a luxury hotel room in Columbus, Ohio", es: "Equipo profesional de limpieza de Flexhire con uniformes negro y dorado preparando una habitación de hotel de lujo en Columbus, Ohio" },
  },
  trust: {
    title: { en: "Why Choose Flexhire Solutions?", es: "¿Por Qué Elegir Flexhire?" },
    subtitle: { en: "Professional staffing and cleaning solutions you can depend on.", es: "Soluciones profesionales de personal y limpieza en las que puede confiar." },
  },
  services: {
    title: { en: "Our Professional Services", es: "Nuestros Servicios" },
    subtitle: { en: "Workforce support solutions customized to your business — cleaning services in Columbus, Ohio and professional staffing on your schedule.", es: "Soluciones de apoyo laboral adaptadas a su negocio — servicios de limpieza en Columbus, Ohio y personal profesional según su horario." },
    learnMore: { en: "Learn More", es: "Más Información" },
    alsoTitle: { en: "Also available", es: "También ofrecemos" },
    customTitle: { en: "Need a mix of services or a crew on short notice?", es: "¿Necesita varios servicios o un equipo con poco aviso?" },
    customCta: { en: "Contact Us for Custom Solutions", es: "Solicite una Solución a Medida" },
  },
  portfolio: {
    title: { en: "Our Professional Work", es: "Nuestro Trabajo Profesional" },
    subtitle: { en: "See the quality and professionalism we bring to every project.", es: "Vea la calidad y el profesionalismo que aportamos a cada proyecto." },
  },
  process: {
    title: { en: "Our Professional Process", es: "Nuestro Proceso" },
    subtitle: { en: "Simple, reliable, professional from start to finish.", es: "Simple, confiable y profesional de principio a fin." },
  },
  about: {
    title: { en: "Professional People. Powerful Results.", es: "Gente Profesional. Resultados Poderosos." },
    subtitle: { en: "We believe in people. We invest in your success.", es: "Creemos en las personas. Invertimos en su éxito." },
  },
  reviews: {
    title: { en: "What Our Clients Say", es: "Lo Que Dicen Nuestros Clientes" },
    subtitle: { en: "Real feedback from businesses we serve.", es: "Comentarios reales de los negocios que atendemos." },
    trusted: { en: "Trusted by 100+ businesses in Columbus", es: "Con la confianza de más de 100 negocios en Columbus" },
    readMore: { en: "Read More Reviews on Google", es: "Ver Más Reseñas en Google" },
    prev: { en: "Previous review", es: "Reseña anterior" },
    next: { en: "Next review", es: "Siguiente reseña" },
    goTo: { en: "Go to review", es: "Ir a la reseña" },
    pause: { en: "Pause rotation", es: "Pausar rotación" },
    play: { en: "Resume rotation", es: "Reanudar rotación" },
  },
  careers: {
    eyebrow: { en: "Your Future Starts Here", es: "Su Futuro Comienza Aquí" },
    title: { en: "Opportunities. Support. A Better Future.", es: "Oportunidades. Apoyo. Un Futuro Mejor." },
    subtitle: { en: "Join a team that values you.", es: "Únase a un equipo que lo valora." },
    belief: { en: "We believe in people. We invest in your success.", es: "Creemos en las personas. Invertimos en su éxito." },
    flagsLabel: { en: "Our team proudly includes people from", es: "Nuestro equipo incluye con orgullo a personas de" },
    stepsTitle: { en: "How to apply", es: "Cómo aplicar" },
    callApply: { en: "Call 614-382-9458 to Apply", es: "Llame al 614-382-9458 para Aplicar" },
    imageAlt: { en: "Diverse Flexhire Solutions team members smiling in black and gold uniforms", es: "Miembros diversos del equipo de Flexhire Solutions sonriendo con uniformes negro y dorado" },
  },
  contact: {
    title: { en: "Ready to Experience Professional Service?", es: "¿Listo para un Servicio Profesional?" },
    subtitle: { en: "Get your free estimate or schedule service today. Limited weekly openings — book your walkthrough now.", es: "Obtenga su estimado gratis o programe su servicio hoy. Cupos semanales limitados — agende su visita ahora." },
    callLabel: { en: "Call now", es: "Llame ahora" },
    emailLabel: { en: "Email", es: "Correo" },
    findUs: { en: "Find Us", es: "Encuéntrenos" },
    viewMap: { en: "View on Google Maps", es: "Ver en Google Maps" },
    mapTitle: { en: "Map showing Flexhire Solutions LLC at 3431 Cleveland Ave, Columbus, OH", es: "Mapa de Flexhire Solutions LLC en 3431 Cleveland Ave, Columbus, OH" },
    hoursLabel: { en: "Hours", es: "Horario" },
    phoneLabel: { en: "Phone", es: "Teléfono" },
    quick: { en: "Quick connect", es: "Contacto rápido" },
    whatsapp: { en: "Message us on WhatsApp", es: "Escríbanos por WhatsApp" },
    privacy: { en: "We respect your privacy. Your information is secure and never shared.", es: "Respetamos su privacidad. Su información está segura y nunca se comparte." },
    promise: { en: "We'll contact you within 24 hours with your free estimate.", es: "Le contactaremos en menos de 24 horas con su estimado gratis." },
    guarantee: { en: "Professional service or your money back.", es: "Servicio profesional o le devolvemos su dinero." },
    formTitle: { en: "Request your free estimate", es: "Solicite su estimado gratis" },
    success: { en: "Thank you! We'll contact you within 24 hours.", es: "¡Gracias! Le contactaremos en menos de 24 horas." },
    another: { en: "Send another request", es: "Enviar otra solicitud" },
  },
  footer: {
    quickLinks: { en: "Quick Links", es: "Enlaces" },
    services: { en: "Services", es: "Servicios" },
    contact: { en: "Contact", es: "Contacto" },
    legal: { en: "Legal", es: "Legal" },
    viewAll: { en: "View All Services", es: "Ver Todos" },
    privacy: { en: "Privacy Policy", es: "Política de Privacidad" },
    terms: { en: "Terms of Service", es: "Términos de Servicio" },
    accessibility: { en: "Accessibility Statement", es: "Declaración de Accesibilidad" },
    newsTitle: { en: "Stay Updated", es: "Manténgase Informado" },
    newsSub: { en: "Staffing tips and seasonal offers, once a month.", es: "Consejos de personal y ofertas de temporada, una vez al mes." },
    newsPlaceholder: { en: "Your email address", es: "Su correo electrónico" },
    subscribe: { en: "Subscribe", es: "Suscribirse" },
    subscribed: { en: "You're subscribed. Thank you!", es: "¡Suscripción confirmada. Gracias!" },
    rights: { en: "All Rights Reserved.", es: "Todos los Derechos Reservados." },
    call: { en: "Call", es: "Llamar" },
    email: { en: "Email", es: "Correo" },
    hours: { en: "Hours", es: "Horario" },
  },
};
